import React from 'react'

import { Alert } from '@mui/material'

type WarningMessageProps = {
	prompt: string
}

const WarningMessage: React.FC<WarningMessageProps> = ({ prompt }) => {
	const isInvalidPrompt = (prompt: string): boolean => {
		const trimmed = prompt.trim()
		return trimmed.split(/\s+/).length > 10
	}

	if (!isInvalidPrompt(prompt)) return null

	return (
		<Alert severity="error">
			Heads up! Your business problem is over 10 words, which may cause
			the facilitation technique to error out on the next page since your
			business problem is part of a much larger prompt for GenAI to react
			to.
		</Alert>
	)
}

export default WarningMessage
